import Api from "@/helpers/api.js";
import { validationStandard } from "@/serviforms/designer/validateSchema/standarSchema.js";
import { vm } from '@/main.js';
import store from '@/serviforms/designer/store';

import { fixPositionQestionsActions } from './fixActions'
import { fixFlexible } from './fixFlexible'

import {
    getQuestionsByPage,
    getListForm,
    createForm,
    createPage,
    createDependence,
    createContador,
    getCounter,
    getAllPages,
    getDependencies,
    getForm,
    setCounter,
    setQuestion,
    getAllQuestion,
    clearIndexDbByIdForm,
    getColumnsOrigin,
    ativeOneForm
} from "../indexDB/logic.js";

import { Default, Label } from "../models/questions.js";
import { notify, confirm, downloadFile } from "../helpers/";

import { recreateIndexDB } from "./getFormToUpdate.js";
import { createJsonForm } from "../helpers/recreateForm";

export default {
    methods: {
        ...recreateIndexDB,
        async clear_form() {
            await clearIndexDbByIdForm();
            const { companyID, uuid } = this.$store.state.user;
            const listForms = await getListForm({ company: companyID, uuid: uuid });
            const result = listForms.filter(form => form.method === "create")[0];

            if (result) {
                const { key } = listForms.filter(form => form.method === "create")[0];
                if (key) await ativeOneForm(key);
            } else if (listForms.length > 0) {
                const { key } = listForms[0];
                if (key) await ativeOneForm(key);
            }

            this.CLEAR_DATA();
            await this.getOrigins();
            await this.getSubformularios();
            if (this.$route.fullPath !== "/dashboard/new/form") {
                this.$router.push({ path: "/dashboard/new/form" });
            }
            this.runApp();
        },
        async clearForm() {
            confirm({
                title: "Confirmar",
                text: "Desea borrar el formulario actual para empezar uno nuevo?",
                accept: this.clear_form
            });
        },
        async question(type) {
            let question = null;
            if (type === 1) {
                question = new Default(`P_${this.counter}`, "input", "Descripción", true, "", "default", { min: 3, max: 20 });
            } else if (type === 2) {
                const properties = {
                    default: "bold",
                    size: 12,
                    color: "#FFFFFF"
                };
                question = new Label(`P_${this.counter}`, "label", "Descripción", false, "", "label", properties, "");
            }

            this.ADD_QUESTION(question.structure());
            this.UPDATE_STATE({ key: "counter", value: this.counter + 1 });
            setQuestion();
            setCounter();

            const allPages = await getAllPages();
            this.UPDATE_STATE({ key: "allPages", value: allPages });

            const htmlBody = document.querySelector("html");
            const scrollHeigthbody = htmlBody.scrollHeight - 750;
            htmlBody.scroll({ top: scrollHeigthbody, behavior: "smooth" });
        },
        async validationsSaveForm() {
            const { nameForm, grupo } = this.dataSidebar;
            if (nameForm.length === 0) {
                notify("Alerta", "Ingrese el nombre para el formulario.", "warning");
                return true;
            }

            if (grupo.length === 0) {
                notify("Alerta", "Seleccione el grupo.", "warning");
                return true;
            }
        },
        async createJsonForm() {
            return createJsonForm();
        },
        async getSubforms(forms, allQuestions) {
            const subforms = forms
                .filter(question => question.type === "subform")
                .map(question => {
                    return {
                        activity: question.inherited[0].activity,
                        formID: question.inherited[0].formID,
                        version: question.inherited[0].version,
                        ...question.properties,
                        question: allQuestions.findIndex(_question => _question.name === question.name),
                        questionID: question.name
                    };
                });
            return subforms;
        },
        async getOrigin(forms, allQuestions) {
            const _colums = await getColumnsOrigin();
            const origins = forms
                .filter(question => {
                    if (question.type === "datasource") {
                        if (question.inputType === "select") {
                            if (question.query.action === "trigger") {
                                return false;
                            }
                        } else if (question.inputType === "standar") return false;
                        return true;
                    }
                    return false;
                })
                .map(question => {
                    let columns = [];
                    if (_colums[question.name]) columns = _colums[question.name];
                    if (question.data) columns = Object.keys(question.data[0]);

                    return {
                        originID: question.properties.originKey,
                        limit: question.properties.limit,
                        question: question.name,
                        questionID: allQuestions.findIndex(_question => _question.name === question.name),
                        columns
                    };
                });
            return origins;
        },
        async getPages() {
            const allPages = await getAllPages();
            let index = 0;
            let sum = 0;
            const orderPages = allPages
                .filter(page => page.questions.length > 0)
                .map((pagina, position) => {
                    sum += pagina.questions.length;
                    var data = {
                        begin: index,
                        end: sum - 1,
                        id: position
                    };
                    index = sum;
                    return data;
                });

            return orderPages;
        },
        async createDataExternal(forms) {
            // forms = this.fixPositionQestionsActions(forms)
            const allQuestions = await getAllQuestion();

            const { nameForm, grupo, isSubForm, formID, companyID } = this.dataSidebar;
            const hasSubforms = await this.getSubforms(forms, allQuestions);
            const hasOrigin = await this.getOrigin(forms, allQuestions);
            const pages = await this.getPages();
            const { simple, compound, listener, dependencias } = await getDependencies();

            const simpleKeys = Object.keys(simple);
            const compoundKeys = Object.keys(compound);
            const listenerKeys = Object.keys(listener);

            let dependencies = {};

            if (simpleKeys.length > 0) dependencies["simple"] = simple;
            if (compoundKeys.length > 0) dependencies["compound"] = compound;
            if (listenerKeys.length > 0) dependencies["listener"] = listener;
            if (dependencias.length > 0) dependencies["relatedness"] = dependencias;

            let formType = "standar";
            if (isSubForm === "1") formType = "subforms";
            if (isSubForm === "2") formType = "bots";

            let dependenciesKeys = Object.keys(dependencies);
            // const fixActions = this.fixPositionQestionsActions(forms)
            const data = {
                formID,
                companyID,
                activity: nameForm,
                groupID: grupo,
                formType,
                SFVersion: 2,
                hasSubForms: false,
                form: {
                    dependencies,
                    pages,
                    questions: forms
                }
            };

            if (dependenciesKeys.length === 0) delete data.form.dependencies;

            if (hasSubforms.length > 0) {
                data.hasSubForms = true;
                data.subforms = hasSubforms;
            }

            if (hasOrigin.length > 0) data.databases = hasOrigin;
            return data;
        },
        async saveForm() {
            const isNext = await this.validationsSaveForm();
            if (isNext) return;
            this.$vs.loading({
                container: "#div-design-form",
                scale: 0.6
            });

            await setQuestion();

            const errorFlex = await fixFlexible();

            if(!errorFlex) {
                this.$vs.loading.close("#div-design-form > .con-vs-loading");
                return notify("Error", 'Algunos componentes flexibles se encuentran mal configurados.', "danger")
            }

            await fixPositionQestionsActions(forms)
            let forms = await this.createJsonForm();
            const result = validationStandard(forms);
            if (!result.valid) {
                const firstElement = result.error[0]

                if (firstElement.hasOwnProperty('parentSchema')) {
                    this.$vs.loading.close("#div-design-form > .con-vs-loading");
                    console.log('firstElement firstElement firstElement ', firstElement)
                    const description = JSON.parse(firstElement.parentSchema.description);
                    if (description.type === 'array') return notify("Error", vm.$t(`MODULE.${description.msg}`), "danger")

                    const data = firstElement.data;
                    const msgDescription = vm.$t(`MODULE.${description.msg}`);
                    const msg = `'${data}' ${msgDescription}`
                    return notify("Error", msg, "danger")
                }
                this.$vs.loading.close("#div-design-form > .con-vs-loading");
            }
            if (forms) {
                const { method } = await getForm();
                const data = await this.createDataExternal(forms);
                const type = method === "update" ? "update" : "create";

                try {
                    if (type === "create") {
                        delete data.formID;
                        delete data.companyID;

                        await this.validator({ form: data, type });

                        const { id } = await this.saveFormAction(data);

                        if (data.formType === "bots") {
                            await this.activeFormVIKI(id, 1);
                            notify("Mensaje", "El formulario se ha guardado y activado para bot.", "success");
                        } else {
                            notify("Mensaje", "El formulario se ha guardado exitosamente.", "success");
                        }

                        await this.clear_form();
                        await this.getForm(id, "last");
                        await this.runApp(id);
                    } else {
                        delete data.companyID
                        delete data.formID
                        await this.validator({ form: data, type });
                        const id = this.$store.state.resource.idForm;
                        const result = await this.updateFormAction({ form: data, key: id });

                        if (data.formType === "bots") {
                            await this.activeFormVIKI(id, result.version);
                            notify("Mensaje", "El formulario se ha guardado y activado para bot.", "success");
                        } else {
                            // notify('Mensaje', 'El formulario se ha guardado exitosamente.', 'success');
                            notify("Mensaje", "El formulario se ha actualizado exitosamente.", "success");
                        }

                        await this.clear_form();
                        // await this.getForm(id, 'last');
                        // await this.runApp(id);
                    }
                } catch (error) {

                    if (typeof error === 'object') {
                        if (error.hasOwnProperty('type') && error.type === 'validate') notify("Error", error.msg, "danger");
                    } else {
                        notify("Error", "Verifique que los campos de las preguntas esten completos.", "danger");
                    }
                    console.log("Error encontrado ", error);
                } finally {
                    this.$vs.loading.close("#div-design-form > .con-vs-loading");
                }
            } else this.$vs.loading.close("#div-design-form > .con-vs-loading");
        },
        async activeFormVIKI(idForm, version) {
            try {
                const data = {
                    formID: idForm,
                    version: version
                };
                await Api.post("/forms/activate", data, { uri: "viki" });
                console.log("El bot se ha activado");
            } catch (error) {
                notify("Error", "No se pudo activar el formulario para el BOT", "danger");
                console.log("Error active bot ", error);
            }
        },
        async donwloadJson() {
            const isNext = await this.validationsSaveForm();
            if (isNext) return;
            const forms = await this.createJsonForm();
            if (forms) {
                const data = await this.createDataExternal(forms);
                if (forms) downloadFile(data, "Formulario");
            }
        },
        async getFormulario() {
            await setQuestion();
            this.visualCode = [];
            this.visualCode = await this.createJsonForm();
            return this.visualCode;
        }
    }
};
